var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "support_input" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [_vm._v("お問い合わせ")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("div", [
              _c("section", { staticClass: "support_section" }, [
                _c("h1", { staticClass: "support_text" }, [
                  _vm._v("フォームでのお問い合わせ")
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "ul_input_support" }, [
                  _c(
                    "li",
                    [
                      _c("div", { staticClass: "supprt_item" }, [
                        _c("span", { staticClass: "support_label" }, [
                          _vm._v(_vm._s(_vm.label.supportTitle))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "important hakoten_small_text" },
                          [_vm._v("必須")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.supportList, function(support) {
                        return _c("div", { key: support.id }, [
                          _c("div", { staticClass: "supprt_item" }, [
                            _c("label", { staticClass: "option_check" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.checkList,
                                    expression: "checkList"
                                  }
                                ],
                                attrs: { type: "checkbox", id: "support.id" },
                                domProps: {
                                  value: support.name,
                                  checked: Array.isArray(_vm.checkList)
                                    ? _vm._i(_vm.checkList, support.name) > -1
                                    : _vm.checkList
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.checkList,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = support.name,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.checkList = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.checkList = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.checkList = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "opt_check" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "opt_label" }, [
                                _vm._v(_vm._s(support.name))
                              ])
                            ])
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _vm.errors.supportTitle
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.supportTitle))
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("span", { staticClass: "support_label" }, [
                        _vm._v(_vm._s(_vm.label.supportBody))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "important hakoten_small_text" },
                        [_vm._v("必須")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.support.supportBody,
                          expression: "support.supportBody"
                        }
                      ],
                      staticClass: "support_msg_area",
                      attrs: { cols: "100", rows: "5", maxlength: "256" },
                      domProps: { value: _vm.support.supportBody },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.support,
                            "supportBody",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.supportBody
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.supportBody))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("span", { staticClass: "support_label" }, [
                        _vm._v(_vm._s(_vm.label.userName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "important hakoten_small_text" },
                        [_vm._v("必須")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "supprt_input_text" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.support.userLastName,
                            expression: "support.userLastName",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "support_sp",
                        attrs: {
                          type: "text",
                          placeholder: "家具",
                          maxlength: "32"
                        },
                        domProps: { value: _vm.support.userLastName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.support,
                              "userLastName",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.support.userFirstName,
                            expression: "support.userFirstName",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "太郎",
                          maxlength: "32"
                        },
                        domProps: { value: _vm.support.userFirstName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.support,
                              "userFirstName",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.errors.userName
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.userName))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("span", { staticClass: "support_label" }, [
                        _vm._v(_vm._s(_vm.label.userNameKana))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "important hakoten_small_text" },
                        [_vm._v("必須")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "supprt_input_text" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.support.userLastNameKana,
                            expression: "support.userLastNameKana",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "support_sp",
                        attrs: {
                          type: "text",
                          placeholder: "カグ",
                          maxlength: "32"
                        },
                        domProps: { value: _vm.support.userLastNameKana },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.support,
                              "userLastNameKana",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.support.userFirstNameKana,
                            expression: "support.userFirstNameKana",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "タロウ",
                          maxlength: "32"
                        },
                        domProps: { value: _vm.support.userFirstNameKana },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.support,
                              "userFirstNameKana",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.errors.userNameKana
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.userNameKana))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("span", { staticClass: "support_label" }, [
                        _vm._v(_vm._s(_vm.label.tel))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "important hakoten_small_text" },
                        [_vm._v("必須")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.support.tel,
                          expression: "support.tel",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "support_msg_area",
                      attrs: {
                        type: "text",
                        oninput: "if(value.length>11)value=value.slice(0,11)",
                        maxlength: "11"
                      },
                      domProps: { value: _vm.support.tel },
                      on: {
                        keypress: _vm.validateNumber,
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.support,
                              "tel",
                              $event.target.value.trim()
                            )
                          },
                          function($event) {
                            _vm.support.tel = _vm.inputRestNumber($event)
                          }
                        ],
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.tel
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.tel))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("span", { staticClass: "support_label" }, [
                        _vm._v(_vm._s(_vm.label.email))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "important hakoten_small_text" },
                        [_vm._v("必須")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.support.email,
                          expression: "support.email",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "support_msg_area",
                      attrs: { type: "text", maxlength: "256" },
                      domProps: { value: _vm.support.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.support,
                            "email",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.email
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.email))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn_pos_center btn_color support_btn",
                    on: {
                      click: function($event) {
                        _vm.cofirm()
                      }
                    }
                  },
                  [_vm._v("内容確認")]
                )
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "support_section" }, [
      _c("div", { staticClass: "support_text" }, [
        _vm._v("お電話でのお問い合わせ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "support_msg" }, [
        _c("div", [
          _vm._v(
            "\n              まずはお気軽にお問い合わせください。\n            "
          )
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("\n              TEL 0575-62-2311\n            ")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n              月〜金曜日（10:00〜17:00）、定休日：土日祝\n            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4181f3f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4181f3f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcSupportInput.vue
// module id = null
// module chunks = 